type Props = {
  image: string;
};

export const GradientShowcase = ({ image }: Props) => (
  <section className='relative flex h-full w-full items-center justify-center overflow-hidden bg-gradient-to-t from-secondary-brand-50 from-[23%] to-secondary-brand-25 to-[95%]'>
    <img src={image} alt='' className='h-auto w-[80%] max-w-[500px] object-contain' />
  </section>
);
